<template>
    <div
      id="nav"
      :class="navContainerSiniflar"
        @mouseover="menuGoster" 
        @mouseleave="menuGizle"
        data-vertical-unpinned="10000"
        data-vertical-mobile="600"
        data-disable-pinning="true"
    >
      <div class="nav-content d-flex">
        <div class="logo position-relative">
          <router-link to="/anasayfa">
            <div class="img"></div>
          </router-link>
        
        
                   

        </div>
    
  
        <div :class="menuContainerSiniflar" @mouseover="menuGoster"
      @mouseleave="menuGizle" >
          <div class="os-resize-observer-host observed">
            <div class="os-resize-observer" style="left: 0px; right: auto"></div>
          </div>
          <div
            class="os-size-auto-observer observed"
            style="height: calc(100% + 1px); float: left"
          >
            <div class="os-resize-observer"></div>
          </div>
          <div
            class="os-content-glue"
            style="margin: 0px; width: 79px; height: 999px"
          ></div>
          <div class="os-padding">
            <div class="os-viewport os-viewport-native-scrollbars-invisible">
              <div
                class="os-content"
                style="padding: 0px; height: 100%; width: 100%"
              >
                <ul id="menu" class="menu show">
                  <li v-if="yetki_kontrol('is_goster')">
                    <router-link to="/anasayfa"  :class="{ active: $route.name === 'anasayfa' }" >
                      <unicon name="estate" class="icon" fill="white"></unicon>
                      <span class="label">Anasayfa</span>
                    </router-link>
                  </li>
                  
                 
                  <li v-if="yetki_kontrol('musteri_ekle')">
                    <router-link to="/musteriler" :class="{ active: $route.name === 'musteriler' }">
                      <unicon name="building" class="icon" fill="white"></unicon>
                      <span class="label">Müşteriler</span>
                    </router-link>
                  </li>

                  <li v-if="yetki_kontrol('musterinot_ekle')">
                    <router-link to="/musterinotlar" :class="{ active: $route.name === 'musterinotlar' }">
                      <unicon name="clipboard-alt" class="icon" fill="white"></unicon>
                      <span class="label">Müşteri Notları</span>
                    </router-link>
                  </li>
                  
                  <li v-if="yetki_kontrol('is_ekle')">
                    <router-link to="/isler" :class="{ active: $route.name === 'isler' }">
                      <unicon name="desktop" class="icon" fill="white"></unicon>
                      <span class="label">İşler</span>
                    </router-link>
                  </li>
                  
                  <li v-if="yetki_kontrol('is_goster')">
                    <router-link to="/elindekiisler" :class="{ active: $route.name === 'ElimdekiIsler' }">
                      <unicon name="briefcase" class="icon" fill="white"></unicon>
                      <span class="label">Elimdeki İşler</span>
                    </router-link>
                  </li>
               
                  
                  <li v-if="yetki_kontrol('yapilacak_ekle')">
                    <router-link to="/yapilacaklar" :class="{ active: $route.name === 'yapilacaklar' }">
                      <unicon name="clipboard-alt" class="icon" fill="white"></unicon>
                      <span class="label">Yapılacaklar</span>
                    </router-link>
                  </li>
                  
                 
                  <li v-if="yetki_kontrol('bildirim_ekle')">
                    <router-link to="/bildirimler" :class="{ active: $route.name === 'bildirimler' }">
                      <unicon name="bell" class="icon" fill="white"></unicon>
                      <span class="label">Bildirimler </span>
                      <span class="badge bg-badge bg-foreground" v-if="bildirimadet!=0">{{ bildirimadet }}</span>
                    </router-link>
                  </li>
                  
                  <li v-if="yetki_kontrol('isfikir_ekle')">
                    <router-link to="/fikirler" :class="{ active: $route.name === 'fikirler' }">
                      <unicon name="lightbulb-alt" class="icon" fill="white"></unicon>
                      <span class="label">İş Fikirleri</span>
                    </router-link>
                  </li>

                  <li v-if="yonetimMenusuGorunur" class="menu-group">
                    <a
                      class="menu-group-toggle"
                      :class="{ active: yonetimRotaAktif }"
                      @click="toggleYonetimMenu"
                    >
                      <unicon name="setting" class="icon" fill="white"></unicon>
                      <span class="label">Yönetim Menü</span>
                      <span class="menu-group-chevron" :class="{ open: yonetimMenuAcik }">▾</span>
                    </a>
                    <ul class="menu-sub" v-show="yonetimMenuAcik">
                      <li v-if="yetki_kontrol('is_goster')">
                        <router-link to="/raporlar" :class="{ active: $route.name === 'raporlar' }">
                          <unicon name="chart-line" class="icon" fill="white"></unicon>
                          <span class="label">Raporlar</span>
                        </router-link>
                      </li>
                      <li v-if="yetki_kontrol('is_goster')">
                        <router-link to="/sistemayarlar" :class="{ active: $route.name === 'sistemayarlar' }">
                          <unicon name="setting" class="icon" fill="white"></unicon>
                          <span class="label">Sistem Ayarlar</span>
                        </router-link>
                      </li>
                      <li v-if="yetki_kontrol('kullanici_ekle')">
                        <router-link to="/kullanicilar" :class="{ active: $route.name === 'kullanicilar' }">
                          <unicon name="user" class="icon" fill="white"></unicon>
                          <span class="label">Kullanıcılar</span>
                        </router-link>
                      </li>
                      <li v-if="yetki_kontrol('rol_ekle')">
                        <router-link to="/roller" :class="{ active: $route.name === 'roller' }">
                          <unicon name="key-skeleton" class="icon" fill="white"></unicon>
                          <span class="label">Roller</span>
                        </router-link>
                      </li>
                      <li v-if="yetki_kontrol('istur_ekle')">
                        <router-link to="/isturler" :class="{ active: $route.name === 'isturler' }">
                          <unicon name="sign-alt" class="icon" fill="white"></unicon>
                          <span class="label">İş Türleri</span>
                        </router-link>
                      </li>
                    </ul>
                  </li>

               

                  <li v-if="yetki_kontrol('is_goster')">
                    <router-link to="/profil" :class="{ active: $route.name === 'profil' }">
                      <unicon name="user-square" class="icon" fill="white"></unicon>
                      <span class="label">Profil</span>
                    </router-link>
                  </li>
               

                   

                    <li>
                    <a @click="cikisYapOnayli">
                      <unicon name="sign-out-alt" class="icon" fill="white"></unicon>
                      <span class="label">Çıkış Yap</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="os-scrollbar os-scrollbar-horizontal os-scrollbar-unusable os-scrollbar-auto-hidden"
          >
            <div class="os-scrollbar-track os-scrollbar-track-off">
              <div
                class="os-scrollbar-handle"
                style="width: 53.6913%; transform: translate(0px, 0px)"
              ></div>
            </div>
          </div>
          <div
            class="os-scrollbar os-scrollbar-vertical os-scrollbar-unusable os-scrollbar-auto-hidden"
          >
            <div class="os-scrollbar-track os-scrollbar-track-off">
              <div
                class="os-scrollbar-handle"
                style="height: 100%; transform: translate(0px, 0px)"
              ></div>
            </div>
          </div>
          <div class="os-scrollbar-corner"></div>
        </div>
        <div class="mobile-buttons-container">
          <router-link to="/" id="scrollSpyButton" class="spy-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="acorn-icons acorn-icons-menu-dropdown undefined"
            >
              <path
                d="M2 3 18 3M2 10 18 10M13 15 10.3536 17.6464C10.1583 17.8417 9.84171 17.8417 9.64645 17.6464L7 15"
              ></path>
            </svg>
          </router-link>
          <div
            class="dropdown-menu dropdown-menu-end"
            id="scrollSpyDropdown"
          ></div>
          <router-link to="#" id="mobileMenuButton" class="menu-button">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="acorn-icons acorn-icons-menu undefined"
            >
              <path d="M2 3 18 3M2 10 18 10M2 17 18 17"></path>
            </svg>
          </router-link>
        </div>
      </div>
      <div class="nav-shadow"></div>
    </div>
    <main>
      <button class="btn btn-icon btn-icon-only btn-foreground hover-outline mb-2"   @click="toggleMenu">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="acorn-icons acorn-icons-arrow-double-right mb-3 d-inline-block text-primary" v-if="menuGorunurluk===false">
        <path d="M8 3L14.6464 9.64645C14.8417 9.84171 14.8417 10.1583 14.6464 10.3536L8 17"></path>
        <path d="M5 6L8.64645 9.64645C8.84171 9.84171 8.84171 10.1583 8.64645 10.3536L5 14"></path>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="acorn-icons acorn-icons-arrow-double-left mb-3 d-inline-block text-primary" v-if="menuGorunurluk===true">
        <path d="M12 17L5.35355 10.3536C5.15829 10.1583 5.15829 9.84171 5.35355 9.64645L12 3"></path>
        <path d="M15 14L11.3536 10.3536C11.1583 10.1583 11.1583 9.84171 11.3536 9.64645L15 6"></path>
      </svg>
    </button>

    <button class="btn btn-icon btn-icon-only btn-foreground hover-outline mb-2 ml-2"   @click="darkMode">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="acorn-icons acorn-icons-arrow-double-left mb-3 d-inline-block text-primary"><path d="M8 14L8.28283 16.4684C8.35276 17.0786 8.38772 17.3837 8.55097 17.6009C8.63047 17.7067 8.73017 17.7956 8.8443 17.8625C9.07862 18 9.38575 18 10 18V18C10.6143 18 10.9214 18 11.1557 17.8625C11.2698 17.7956 11.3695 17.7067 11.449 17.6009C11.6123 17.3837 11.6472 17.0786 11.7172 16.4684L12 14"></path><path d="M15 7C15 10.1518 13.5 10.5 13 11.5C12.5 12.5 12.6096 14.5 10 14.5C7.39038 14.5 7.5 12.5 7 11.5C6.5 10.5 5 10.1518 5 7C5 4.23858 7.23858 2 10 2C12.7614 2 15 4.23858 15 7Z"></path></svg>
    </button>

      
      <slot></slot></main>
  </template>
  
  <script>
  
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import { bildirimAdetSession } from '@/services/useToken';
import { isAgencyAuthenticated } from '@/services/auth';

  export default {
    data() {
      return {
        menuGorunurluk: false,
        bildirimadet:0,
        darkmode : false,
        bildirimAdetInterval: null, // interval referansı
        bildirimAudio: null, // bildirim sesi
        yonetimMenuAcik: false,
      };
    },
    computed: {
    menuContainerSiniflar() {
      return {
        "menu-container": true,
        "flex-grow-1": true,
        "os-host": true,
        "os-theme-dark": true,
        "os-host-resize-disabled": true,
        "os-host-scrollbar-horizontal-hidden": true,
        "os-host-scrollbar-vertical-hidden": true,
        "os-host-transition": true,
        "os-host-overflow": !this.menuGorunurluk,
        "os-host-overflow-x": !this.menuGorunurluk,
      };
    },
    navContainerSiniflar() {
      return {
        "nav-container": true,
        goster: this.menuGorunurluk,
        "d-flex": true,
      };
    },
    yonetimRotaAktif() {
      return ["raporlar", "sistemayarlar", "kullanicilar", "roller", "isturler"].includes(this.$route.name);
    },
    yonetimMenusuGorunur() {
      return (
        this.yetki_kontrol("is_goster") ||
        this.yetki_kontrol("kullanici_ekle") ||
        this.yetki_kontrol("rol_ekle") ||
        this.yetki_kontrol("istur_ekle")
      );
    },
  },
  watch: {
    "$route.name"(yeniRota) {
      if (["raporlar", "sistemayarlar", "kullanicilar", "roller", "isturler"].includes(yeniRota)) {
        this.yonetimMenuAcik = true;
      }
    },
  },

  mounted() {

    

      if (!isAgencyAuthenticated()) {
        this.$router.replace({ name: 'Login' });
      }

        this.bildirimAdetGetir();
    this.bildirimAudio = new Audio('/notification.mp3');

    // Kullanıcı ilk tıkladığında sesi başlatıp izin al
 

    // Periyodik olarak bildirim adeti güncelle
    this.bildirimAdetInterval = setInterval(() => {
      this.bildirimAdetGetir();
    }, 5000); // 5 saniyede bir
    this.yonetimMenuAcik = this.yonetimRotaAktif;
  },
  beforeUnmount() {
    // Timer'ı temizle
    if (this.bildirimAdetInterval) {
      clearInterval(this.bildirimAdetInterval);
      this.bildirimAdetInterval = null;
    }
  },
    methods: {
      yetki_kontrol(yetki){
        return yetkiKontrol(yetki);
      },
      menuGoster() {
        this.menuGorunurluk = true;

      },
      darkMode() {
      
        if(this.darkmode==false){
          document.getElementById("html").setAttribute('data-color', 'dark-red');
        this.darkmode = true;
        }else{
          document.getElementById("html").setAttribute('data-color', 'red');
         this.darkmode = false;
        }
      
      },

    menuGizle() {
        this.menuGorunurluk = false;

    },
    toggleMenu() {
      this.menuGorunurluk = !this.menuGorunurluk; 
    },
    toggleYonetimMenu() {
      this.yonetimMenuAcik = !this.yonetimMenuAcik;
    },
    bildirimAdetGetir() {
      axiosCustom
        .get("anasayfa/bildirimadet")
        .then((response) => {
          const yeniAdet = response.data.adet;
          // Eğer localStorage'daki değerden büyükse ses çal
          if (yeniAdet > bildirimAdetSession.value) {
            if (this.bildirimAudio) {
              this.bildirimAudio.play();
            }
          }
          // Her durumda yeni değeri kaydet
          bildirimAdetSession.value = yeniAdet;
          this.bildirimadet = yeniAdet;
          // Sayfa başlığını güncelle
          if (yeniAdet > 0) {
            document.title = `(${yeniAdet}) Takip Uygulaması `;
          } else {
            document.title = 'Takip Uygulaması';
          }
        })
        .catch((error) => {
          console.error("Veri çekme hatası: ", error);
        });
    },
      async cikisYapOnayli() {
        const result = await this.$swal({
          title: 'Çıkış yapılsın mı?',
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: 'Evet',
          cancelButtonText: 'Hayır',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
        });
        if (result.isConfirmed) {
          this.$globalVariable.cikisYap();
        }
      },
      
    },
  };
  </script>

<style scoped>
:deep(.menu-container) {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
}

:deep(.menu-container .os-viewport) {
  height: calc(100vh - 64px);
  max-height: calc(100vh - 64px);
  overflow-y: auto !important;
  overflow-x: hidden;
  scrollbar-gutter: stable;
  padding-bottom: 56px;
}

:deep(#menu.menu) {
  padding-bottom: calc(96px + env(safe-area-inset-bottom));
}

:deep(#menu.menu > li:last-child) {
  margin-bottom: 8px;
}

:deep(#menu .menu-group-toggle) {
  cursor: pointer;
}

:deep(#menu .menu-group-chevron) {
  margin-left: auto;
  font-size: 13px;
  opacity: 0.85;
  transition: transform 0.2s ease;
}

:deep(#menu .menu-group-chevron.open) {
  transform: rotate(180deg);
}

:deep(#menu .menu-sub) {
  list-style: none;
  margin: 4px 0 10px 0;
  padding-left: 10px;
}

:deep(#menu .menu-sub > li > a) {
  border-radius: 12px;
}
</style>
  